import React from "react";
import { Box } from "@mui/material";

export default function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;
}
